<template>
	<div>
		<div class="price-page">
			<div class="faq-block__answer">
				<div class="text-section">
					<table>
						<thead>
						<tr>
							<th>{{ Lang.get('common.analiz_name') }}</th>
							<th>{{ Lang.get('common.analiz_code') }}</th>
							<th>{{ Lang.get('common.price') }}</th>
						</tr>
						</thead>
						<tbody>
						<tr v-if="services.length > 0" v-for="item in services">
							<td>{{ item.service.name }}</td>
							<td>{{ item.cartService.code }}</td>
							<td>{{
									item.cartService.with_discount ? item.cartService.with_discount :
										item.cartService.price
								}} грн.
								<div class="delete" @click="removeService(item.service.id)"></div>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div style="color:red; font-size: 18px; font-weight:bold; margin:10px 0px;">
				*Під час відвідання відділення
				згідно Вашого замовлення, додатково необхідно сплатити вартість взяття біологічного матеріалу.
			</div>
			<div class="warning-text" v-if="specialPoint()" v-html="Lang.get('js.cart.warning_cart')"></div>
		</div>
		<div class="cart-total">{{ Lang.get('js.cart_sum') }}: {{ cart.getTotalServicesPrice() }} грн.</div>
		<div class="form">
			<div class="block-h2">{{ Lang.get('js.user_data') }}</div>
			<form method="POST"
				  @submit.prevent
				  @keydown="form.errors.clear($event.target.name)">
				<div class="row">
					<div class="form-group col-6">
						<input type="text"
							   class="form-control"
							   name="name"
							   :placeholder="Lang.get('js.cart.name')"
							   v-model="form.name"
						>
						<span class="text-danger"
							  v-if="form.errors.has('name')"
							  v-text="form.errors.get('name')">
                    </span>
					</div>
					<div class="form-group col-6">
						<input type="text"
							   class="form-control"
							   name="secondname"
							   :placeholder="Lang.get('js.cart.secondname')"
							   v-model="form.secondname"
						>
						<span class="text-danger"
							  v-if="form.errors.has('secondname')"
							  v-text="form.errors.get('secondname')">
                    </span>
					</div>
					<div class="form-group col-6">
						<input type="text"
							   class="form-control"
							   name="patronymic"
							   :placeholder="Lang.get('js.cart.patronymic')"
							   v-model="form.patronymic"
						>
						<span class="text-danger"
							  v-if="form.errors.has('patronymic')"
							  v-text="form.errors.get('patronymic')">
                    </span>
					</div>
					<div class="form-group col-6">
						<!--            <input type="text"-->
						<!--                   class="form-control"-->
						<!--                   name="birthday_date"-->
						<!--                   :placeholder="Lang.get('js.cart.birthday_date')"-->
						<!--                   v-model="form.birthday_date"-->
						<!--            >-->
						<input type="text" name="birthday_date"
							   class="form-control"
							   v-model="form.birthday_date"
							   :placeholder="Lang.get('js.cart.birthday_date')" value=""
							   min="1900-01-01" max="2030-12-31">
						<span class="text-danger"
							  v-if="form.errors.has('birthday_date')"
							  v-text="form.errors.get('birthday_date')">
                    </span>
					</div>
					<div class="form-group col-12">
						<p class="label">{{ Lang.get('js.gender') }}:</p>
						<div class="form-check" v-for="(index, value) in genderList">
							<input class="form-check-input" type="radio" v-model="form.gender" :name="value"
								   :id="`gender-${value}`"
								   :value="value">
							<label class="form-check-label" :for="`gender-${value}`">
								{{ index }}
							</label>
						</div>
					</div>
					<div class="form-group col-12 col-md-4">
						<input type="text"
							   class="form-control"
							   name="email"
							   placeholder="E-Mail"
							   v-model="form.email"
						>
						<span class="text-danger"
							  v-if="form.errors.has('email')"
							  v-text="form.errors.get('email')">
                    </span>
					</div>
					<div class="form-group col-12 col-md-4">
						<input type="text"
							   class="form-control"
							   name="phone"
							   :placeholder="Lang.get('js.cart.phone')"
							   v-model="form.phone"
						>
						<span class="text-danger"
							  v-if="form.errors.has('phone')"
							  v-text="form.errors.get('phone')">
                    </span>
					</div>
					<div class="form-group col-12 col-md-4">
						<el-select v-model="department_sel"
								   :placeholder="Lang.get('js.select_department')">
							<el-option
								v-for="(item,index) in selected_department"
								:key="index"
								:label="item[`name`]"
								:value="index">
							</el-option>
						</el-select>
					</div>

<!--					<div class="form-group col-12 col-md-4">-->
<!--						<el-select v-model="form.department"-->
<!--								   :placeholder="Lang.get('js.select_department')">-->
<!--							<el-option-->
<!--								v-for="(item,index) in selected_department"-->
<!--								:key="index"-->
<!--								:label="item[`title_${Lang.locale}`]"-->
<!--								:value="index">-->
<!--							</el-option>-->
<!--						</el-select>-->
<!--					</div>-->
					<div class="form-group col-12">
                    <textarea
						class="form-control"
						name="comment"
						:placeholder="Lang.get('js.cart.comment')"
						v-model="form.comment"
					></textarea>
						<span class="text-danger"
							  v-if="form.errors.has('comment')"
							  v-text="form.errors.get('comment')">
                    </span>
					</div>
				</div>


			</form>

		</div>
		<div class="policy">
			<p>Натискаючи ЗАМОВИТИ, Я погоджуюсь з умовами <a
				href="/publichnii-dogovir-pro-nadannia-medichnikh-poslug-publichna-oferta" title="Публічного Договору">Публічного
				Договору</a> та <a href="/pravila-perebuvannia-patsiientiv-u-zakladi-tov-artmediuz"
								   title="Правила перебування">Правила перебування пацієнтів у закладах ТОВ
				«Артмедіуз»</a>.</p>
		</div>
		<div class="row mt-5">
			<div
				class="col-12 col-sm-6 left d-flex align-items-center mb-3 mb-sm-0 justify-content-center justify-content-sm-start">
				<a :href="continueUrl" class="my-cart-button grey">{{ Lang.get('js.cart_continue') }}</a>
			</div>
			<div class="col-12 col-sm-6 right d-flex align-items-center justify-content-center justify-content-sm-end">
				<!--                <div @click="goToOrder" class="my-cart-button"></div>-->
				<div class="my-cart-button" @click="compleateOrder()">{{ Lang.get('js.cart_order2') }}</div>
			</div>
		</div>

		<div class="processing" v-if="loadProcessing">
			<div class="d-flex flex-column align-items-center justify-content-center h-100">
				<div class="load">
					<img src="/local_image/loading.svg" alt="Ваше замовлення обробляється">
				</div>
				<div class="text">Ваше замовлення обробляється</div>
			</div>
		</div>

	</div>
</template>

<script>
import Textarea from "../Textarea";

export default {
	name: 'cart',
	components: {Textarea},
	data() {
		return {
			cart: window.cart,
			services: {},
			selected_department,
			defaultLanguage,
			continueUrl: Lang.locale === defaultLanguage ? '/laboratornye-issledovaniia' : '/ua/laboratorni-doslidzhennia',
			Lang,
			genderList: {
				'male': Lang.get('js.male'),
				'female': Lang.get('js.female')
			},
			loadProcessing: false,
			department_sel: '',
			form: new Form(
				{
					name: '',
					secondname: '',
					patronymic: '',
					birthday_date: '',
					department: '',
					gender: 'male',
					email: '',
					phone: '',
					comment: '',
					department_name: '',
					chat_id: '',
					admin_email: '',
				}
			)
		}
	},
	watch: {
		department_sel: {
			handler: function (newVal, oldVal) {
				this.sendNewPointValues();
			},
			deep: true
		},
	},
	methods: {
		sendNewPointValues () {
			this.form.department = this.department_sel;
			this.form.department_name = this.selected_department[this.department_sel].name;
			this.form.chat_id = this.selected_department[this.department_sel].chat_id;
			this.form.admin_email = this.selected_department[this.department_sel].admin_email;

		},
		goToOrder() {
			let length = this.services.length;
			let codeString = '';
			this.services.forEach((item, index) => {
				if (index < length - 1) {
					codeString = codeString + item.service.code + ',';
				} else if (index === length - 1) {
					codeString = codeString + item.service.code;
				}
			});
			let url = 'http://artmediuz.medcloud.pro/?tests=' + codeString + '&tab=cart';
			this.removeService(null);
			location.href = url;
		},
		removeService(id) {
			axios.post('/cart/' + this.cart.orderId + '/delete', {
				id: id
			}).then(res => {
				this.getCartData();
			});

		},
		specialPoint() {
			let point = false;
			Array.from(this.services).forEach((item, index) => {
				if (item.service.special_points === 1) {
					point = true;
				}
			});
			return point;

			// this.services.forEach((item, index) => {
			//   console.log(item.service.special_points);
			//   if(item.service.special_points === 1) {
			//     return true;
			//   }
			// });
			// return false;
		},
		compleateOrder() {
			this.loadProcessing = true;
			this.loading = true;
			this.isDisabled = true;

			this.form.department_name = selected_department[this.form.department].name;
			this.form.chat_id = selected_department[this.form.department].chat_id;
			this.form.admin_email = selected_department[this.form.department].admin_email;

			let lang_post = this.Lang.locale != 'ru' ? '/cart/' : `/${this.Lang.locale}/cart/`;
			this.form.post(lang_post + this.cart.orderId + '/compleate').then(res => {
				window.location.replace(res.redirect);
			}).catch(rej => {
				this.loadProcessing = false;
				this.loading = false;
				this.isDisabled = false;
			});
		},
		getCartData() {
			axios.post('/cart/get').then(res => {
				this.services = res.data.items;
			});
		}
	},
	mounted() {
		this.getCartData();
	},
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/order/Cart.vue